import { createAction } from 'redux-actions'

export const types = {
    ASSIGN_DASHBOARD_SETTINGS: 'dashboards/ASSIGN_DASHBOARD_SETTINGS',
    POPULATE_DASHBOARD_DATA: 'dashboards/POPULATE_DASHBOARD_DATA',
    SHOW_BAR: 'dashboards/SHOW_BAR',
    SHOW_DOLLARS: 'dashboards/SHOW_DOLLARS',
    SHOW_DONORS: 'dashboards/SHOW_DONORS',
    SHOW_LINE: 'dashboards/SHOW_LINE',
    UPDATE_LEGEND: 'dashboards/UPDATE_LEGEND',
}

export const actions = {
    assignDashboardSettings: createAction<DashboardSettingsDto>(types.ASSIGN_DASHBOARD_SETTINGS),
    populateDashboardData: createAction<any>(types.POPULATE_DASHBOARD_DATA),
    showBar: createAction(types.SHOW_BAR),
    showDollars: createAction(types.SHOW_DOLLARS),
    showDonors: createAction(types.SHOW_DONORS),
    showLine: createAction(types.SHOW_LINE),
    updateLegend: createAction<LegendItems>(types.UPDATE_LEGEND),
}
